import React, { useEffect, useState } from 'react';
import { Pencil } from "lucide-react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

const PersonaNudgeTitle = ({ userPersonas, setUserPersonas, userPersonaKey }) => {
  const [nudgeDisplayName, setNudgeDisplayName] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  // Load the persona name when userPersonas or userPersonaKey changes
  useEffect(() => {
    const selectedPersona = userPersonas?.find(persona => persona.optionValue === userPersonaKey);
    if (selectedPersona) {
      setNudgeDisplayName(selectedPersona.optionName);
    }
  }, [userPersonas, userPersonaKey]);

  const handleDisplayNameClick = () => {
    setIsEditing(true); // Enable editing mode
  };

  const handleDisplayNameChange = (e) => {
    const newDisplayName = e.target.value;
    setNudgeDisplayName(newDisplayName); // Update the display name locally

    // Update userPersonas state without mutating the original array
    const updatedUserPersonas = userPersonas.map(persona =>
      persona.optionValue === userPersonaKey
        ? { ...persona, optionName: newDisplayName }
        : persona
    );

    setUserPersonas(updatedUserPersonas);
  };

  const handleBlurOrEnter = () => {
    setIsEditing(false); // Disable editing mode when input is blurred or Enter is pressed
  };


  return (
    <div className="relative flex items-center justify-center">
      <p className="nudge__title text-base sm:text-2xl text-center relative flex items-center gap-2">
        {isEditing ? (
          <input
            type="text"
            value={nudgeDisplayName}
            onChange={handleDisplayNameChange}
            onBlur={handleBlurOrEnter}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleBlurOrEnter();
              }
            }}
            className="border-2 text-gray-700 border-blue-500 p-2 px-3 rounded-lg text-lg font-semibold focus:outline-none focus:border-blue-700 shadow-lg transition-all duration-300 min-w-[320px] w-96"
            autoFocus
          />
        ) : (
          <span onClick={handleDisplayNameClick} className="cursor-pointer relative flex items-center">
            {nudgeDisplayName}
            <Pencil
              className="ml-2 w-5 h-5 text-green-400 hover:text-blue-500 cursor-pointer transition-all duration-200"
              onClick={handleDisplayNameClick}
            />
          </span>
        )}
      </p>
    </div>
  );
};

export default PersonaNudgeTitle;
